import React, { Component } from 'react'
import {Link} from "react-router-dom";
export class Aside extends Component {
    state ={
 
    }

    componentDidMount(){
        
    }
    
    render() {
       
        return (
            <div>
                <ul className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" id="accordionSidebar">
                    <Link className="sidebar-brand d-flex align-items-center justify-content-center" to="/dashboard">
                        <div className="sidebar-brand-icon rotate-n-15">
                        <i className="fas fa-laugh-wink"></i>
                        </div>
                    <div className="sidebar-brand-text mx-3">{"STUDENT"}</div>
                    </Link>
                    <hr className="sidebar-divider my-0"/>

                    <li className="nav-item ">
                        <Link to="/dashboard" className="nav-link" >
                        <i className="fas fa-fw fa-tachometer-alt"></i>
                        <span>Dashboard</span></Link>
                    </li>
                    <hr className="sidebar-divider"/>
            
                    {/*STUDENT */}
                    <div>
                       

                        <li className="nav-item ">
                            <Link to="/addApplication" className="nav-link" >
                            <i className="fas fa-fw fa-tachometer-alt"></i>
                            <span>Add Application</span></Link>
                        </li>
                        <hr className="sidebar-divider"/>

                        <li className="nav-item ">
                            <Link to="/seeApplication" className="nav-link" >
                            <i className="fas fa-fw fa-tachometer-alt"></i>
                            <span>See Application</span></Link>
                        </li>
                        <hr className="sidebar-divider"/>

                      

                    </div>
             
                    <div className="text-center d-none d-md-inline">
                        <button className="rounded-circle border-0" id="sidebarToggle"></button>
                    </div>

                </ul>
            </div>
        )
    }
}

export default (Aside)
